import { useRef } from "react";

export default function useMenuPortalTargetRef() {
  return useRef(document.querySelector("body"));
}
